import React from 'react'
import { Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../model/rootReducer'
const { Option } = Select

type BotSelectorProps = {
    onBotSelect: (id: string) => void
}

export const BotSelector: React.FunctionComponent<BotSelectorProps> = ({onBotSelect}) => {
    const bots = useSelector((state: RootState) => state.bot.bots)
    const selectedBot = useSelector((state: RootState) => state.bot.selectedBot)
    const dispatch = useDispatch();

    return (
        <>
            <Select
                value={selectedBot}
                style={{ width: 200 }}
                onChange={(id: string) => {dispatch(onBotSelect(id))}}
            >
            {bots.map((item) => 
                <Option value={item.id!}>{item.name}</Option>
            )}
            </Select>
        </>
    )
}

export default BotSelector
